module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.searchQuery && _vm.filteredRowsToIterate.length == 0) ? _c('div', [_c('b-alert', {
    attrs: {
      "show": "",
      "variant": "info"
    }
  }, [_vm._v("No requirements found for your search query")])], 1) : (_vm.rows.length > 0) ? _c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_vm._l((_vm.headerRow), function(header) {
    return _c('th', [_vm._v(_vm._s(header))])
  }), _vm._v(" "), _vm._l((_vm.selectedIssueTypeColumns), function(issueType) {
    return _c('th', {
      attrs: {
        "id": issueType.name
      }
    }, [_vm._v(_vm._s(issueType.name))])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredRowsToIterate), function(row) {
    return _c('tr', [_vm._l((row.requirements), function(requirement) {
      return _c('td', [(requirement.requirement_id != null) ? _c('div', [(requirement.atlassian_status_id != null && _vm.statusMap.has(requirement.atlassian_status_id.toString())) ? _c('span', {
        directives: [{
          name: "b-popover",
          rawName: "v-b-popover.hover",
          value: (_vm.statusMap.get(requirement.atlassian_status_id.toString()).name),
          expression: "statusMap.get(requirement.atlassian_status_id.toString()).name",
          modifiers: {
            "hover": true
          }
        }],
        class: _vm.getLozengeClassFromStatusCategory(_vm.statusMap.get(requirement.atlassian_status_id.toString()).statusCategory.key)
      }) : _vm._e(), _vm._v(" "), _c('a', {
        staticClass: "matrix-item-id",
        attrs: {
          "href": _vm.getNewTabLink(requirement.requirement_id),
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(requirement.prefix) + _vm._s(requirement.display_id ? requirement.display_id : requirement.requirement_id))]), _vm._v(" "), _c('div', {
        staticClass: "matrix-item-name"
      }, [_vm._v("\n            " + _vm._s(requirement.name) + "\n          ")])]) : _c('div', [_vm._v("-")])])
    }), _vm._v(" "), _vm._l((_vm.selectedIssueTypeColumns), function(issueType) {
      return _c('td', {
        attrs: {
          "headers": issueType.name
        }
      }, _vm._l((row.issues), function(issue) {
        return (_vm.issueLookup[issue.atlassian_issue_id] && _vm.issueLookup[issue.atlassian_issue_id].fields.issuetype.id === issueType.id) ? _c('div', [_c('span', {
          directives: [{
            name: "b-popover",
            rawName: "v-b-popover.hover",
            value: (_vm.issueLookup[issue.atlassian_issue_id].fields.status.name),
            expression: "issueLookup[issue.atlassian_issue_id].fields.status.name",
            modifiers: {
              "hover": true
            }
          }],
          class: _vm.getLozengeClassFromStatusCategory(_vm.issueLookup[issue.atlassian_issue_id].fields.status.statusCategory.key)
        }), _vm._v(" "), _c('a', {
          staticClass: "matrix-item-id",
          attrs: {
            "target": "_blank",
            "href": ((_vm.$auth.user().atlassian_base_url) + "/browse/" + (_vm.issueLookup[issue.atlassian_issue_id].key))
          }
        }, [_vm._v(_vm._s(_vm.issueLookup[issue.atlassian_issue_id].key))]), _vm._v(" "), _c('div', {
          staticClass: "matrix-item-name"
        }, [_vm._v("\n            " + _vm._s(_vm.issueLookup[issue.atlassian_issue_id].fields.summary) + " \n          ")])]) : _vm._e()
      }))
    })], 2)
  }))]) : (_vm.loading) ? _c('div', [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": "",
      "scale": "5"
    }
  })], 1)]) : _c('div', [_c('b-alert', {
    attrs: {
      "show": "",
      "variant": "info"
    }
  }, [_vm._v("Please create at least one requirement to view the traceability matrix")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-734da580"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TraceabilityMatrixGrid.vue
// module id = 1018
// module chunks = 1